import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import { TextBox } from "../../Components/InputElements";
import Select from 'react-select';
import { NoRecords } from "../../Components/Shimmer";
import { decodeData } from "../../Constants/constants";

class DocumentVerification extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      location_title: "",
      location_description: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Employees/GetEmployeesByDocumentVerification`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  handleDelete = (id) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.setState({ status: true });
        const formData = {
          employee_id: id,
        };
        axios
          .post(`${apiURL}Employees/DeleteEmployee`, formData, { headers })
          .then((response) => {
            Swal.fire({
              title: `<strong>${response.data.success === true ? "Success" : "Failed"
                }</strong>`,
              text: response.data.message,
              icon: response.data.success === true ? "success" : "error",
            });
            this.setState({ status: false });
            if (response.data.success === true) {
              this.setState({ loadingList: true }, (prevState) => {
                this.GetList();
              });
            }
          })
          .catch((error) => {
            // Handle any errors that occur during the request
            Swal.fire({
              title: <strong>Error</strong>,
              html: error,
              icon: "error",
            });
          });
      }
    });
  };

  handleInputSearch = (e) => {
    this.GetList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      if (this.state.keyword === "") {
        this.GetList();
      }
    });
  };
  handleSelectChange = (selectedOption) => {
    this.setState({ selectOption: selectedOption });
  };
  handleClearAll = () => {
    this.setState({
      employee_id: 0,
      location_title: "",
      location_description: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: "",
    }
      , () => {
        this.GetList();
      });
  };


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList(); // This will log the updated state value
        }
      );
    }
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList(); // This will log the updated state value
      }
    );
  };
  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500, this.state.total_records];
    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Document Verification List`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header align-items-center d-flex">
                    {/* <h4 className="card-title mb-0 flex-grow-1">Master Leave Type List</h4> */}
                    <div className='col-md-4'>
                      <label htmlFor="keyword">Enter keyword</label>
                      <div className="input-group">
                        <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by keyword" />
                        <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="row">
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                        </div>
                        <div className='col-md-1'></div>
                        <div className='col-md-5'>
                          <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-1'></div>
                    <div className='col-md-3'>
                      <div className="row">
                        {/* <div className='col-md-6'>
                          <div>
                            <label>Select option</label>
                          </div>
                          <Select
                            options={options}
                            value={this.state.selectOption}
                            onChange={this.handleSelectChange}
                            placeholder="Select Option"
                          />
                        </div> */}
                        <div className='col-md-7'></div>
                        <div className='col-md-5'>
                          <div>
                            <label>Show All </label>
                          </div>
                          <button
                            type="button"
                            className={`btn btn-secondary btn-sm btn-label right ms-auto nexttab nexttab ${(!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption) ? 'disabled' : ''}`}
                            onClick={this.handleClearAll}
                            disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption}
                          >
                            <i className=" ri-database-2-line label-icon align-middle fs-16 ms-2"></i> Show All

                          </button>
                        </div>
                      </div>
                    </div>
                    <div style={{ width: '10px' }}></div>
                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-stripped`}>
                      <thead className="table-light">
                        <tr>
                          <th>Employee Code</th>
                          <th>Employee Name</th>
                          <th>Employee Mobile Number</th>
                          <th>Employee Email Address</th>
                          <th>Employee Address</th>
                          <th>Employee Document Status</th>

                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      {this.state.rows.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={11}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) :
                        <tbody>
                          {this.state.rows.map((row) => {
                            return (
                              <tr key={row.employee_id}>
                                <td>{row.employee_code}</td>
                                <td>
                                  <NavLink to={`/Profile/${row.employee_id}`}>
                                    {row.employee_name}
                                  </NavLink>
                                </td>
                                <td>{row.employee_mobile_number}</td>
                                <td>{row.employee_email_address}</td>
                                <td>{row.employee_address}</td>
                                <td><span className={`badge bg-${row.verification_status_class}`} >{row.verification_status_label}</span></td>
                                <td className="d-flex justify-content-around">
                                  {/* <NavLink to={`/Documents/${row.employee_id}`}> */}
                                  <NavLink to={`/Profile/${row.employee_id}`}>
                                    <button
                                      type="button"
                                      className={`btn btn-success btn-sm btn-label waves-effect right waves-light`}
                                    >
                                      <i className=" ri-file-upload-line label-icon align-middle fs-16 ms-2" />
                                      Document
                                    </button>
                                  </NavLink>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>}
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={8}>
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  this.state.prev === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handlePrev()}
                                className={`btn btn-warning btn-label waves-effect waves-light`}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div
                                className="col-md-4"
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                {
                                  <small>
                                    Total Records: {this.state.total_records} |
                                    Total Pages: {this.state.total_pages} |
                                    Current Page: {this.state.page}
                                  </small>
                                }
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={(e) => this.handleChange(e)}
                                >
                                  {Array.from(
                                    { length: this.state.total_pages },
                                    (_, i) => (
                                      <option
                                        selected={this.state.page === i + 1}
                                        key={i}
                                        value={i + 1}
                                      >
                                        Page {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={this.handleLimitChange}
                                  value={this.state.limit}
                                >
                                  <option value={this.state.total_records}>All</option>
                                  {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                      Limit {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <button
                                disabled={
                                  this.state.next === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                              >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(DocumentVerification);
